var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeta1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M178.94 175.475c-34.817 0-64.024 59.899-64.024 118.478 0 27.382 10.396 42.738 27.887 42.738 16.996 0 27.557-10.726 58.084-58.579 0 0 13.882-22.046 36.799-57.197-24.135-34.551-39.892-45.44-58.746-45.44zM331.905 167.224c-18.666 0-34.36 14.633-53.386 43.999 5.283 7.828 10.758 16.365 16.471 25.657l21.11 35.207c33.014 53.12 41.321 64.603 58.708 64.603 18.141 0 26.897-15.511 26.897-42.243-.001-70.129-31.023-127.223-69.8-127.223z",
    fill: "#0588ff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 0C114.615 0 0 114.615 0 256s114.615 256 256 256 256-114.615 256-256S397.385 0 256 0zm117.983 375.633c-34.724 0-53.887-19.505-88.281-77.06l-17.656-29.702a1232.107 1232.107 0 0 0-11.955-19.748c-10.797 19.093-26.493 46.81-26.493 46.81-37.652 65.816-58.832 79.7-88.281 79.7-40.916 0-65.344-31.847-65.344-82.34 0-80.69 44.883-156.925 103.462-156.925 28.732 0 52.742 13.929 81.451 50.483 20.892-28.247 43.97-50.483 73.494-50.483 55.752 0 101.647 70.955 101.647 155.44-.001 51.542-22.184 83.825-62.044 83.825z",
    fill: "#0588ff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta1);
export default __webpack_public_path__ + "static/media/meta (1).a5168673160e2f15b5293c3d4ea65489.svg";
export { ForwardRef as ReactComponent };